import { render, staticRenderFns } from "./RasConfigurazionePostiLettoStanzeListPage.vue?vue&type=template&id=244f2088"
import script from "./RasConfigurazionePostiLettoStanzeListPage.vue?vue&type=script&lang=js"
export * from "./RasConfigurazionePostiLettoStanzeListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports